import PropTypes from 'prop-types';
import Prices from './Prices';

const productHasVariants = (product, isTottusSA = false) => product?.variants[0]?.options.length > 0 && isTottusSA;

const PricesWrapper = ({ product, selectedVariant, isTottusSA = false, isOverridePriceRanges = false, ...rest }) => {
  const isVariant = productHasVariants(product, isTottusSA);
  const variantPrices = selectedVariant?.sizes?.[0]?.prices?.length > 0 ? selectedVariant.sizes[0].prices : [];

  const priceList = !isOverridePriceRanges && isTottusSA && variantPrices.length > 0 ? variantPrices : product.prices;

  return (
    <Prices {...rest} priceList={priceList} productId={product.productId} product={product} isVariant={isVariant} />
  );
};

PricesWrapper.propTypes = {
  product: PropTypes.object.isRequired,
  selectedVariant: PropTypes.object,
  isTottusSA: PropTypes.bool.isRequired,
  isOverridePriceRanges: PropTypes.bool.isRequired,
};

PricesWrapper.defaultProps = {
  selectedVariant: null,
};

export { PricesWrapper };
